import { FormGroup, ValidationErrors } from '@angular/forms';

// Validator that requires at least 1 control in the group to be truthy
export const atLeastOne = () => (group: FormGroup): ValidationErrors | null => {
  const hasAtLeastOne =
    group &&
    group.controls &&
    Object.keys(group.controls).some(k => {
      return !!group.controls[k].value;
    });

  return hasAtLeastOne
    ? null
    : {
        atLeastOne: true,
      };
};
